"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUnifiedProfileResponseApiDomain = exports.GetUnifiedProfileResponseDataApiDomain = exports.CognitoUserProfile = exports.SsoUserProfile = exports.MobileOtpProfile = exports.GuestEnhancedProfile = exports.GuestProfile = exports.WogUserProfile = exports.MolUserProfile = exports.ProfileType = void 0;
const class_transformer_1 = require("class-transformer");
const service_1 = require("../../service");
var ProfileType;
(function (ProfileType) {
    ProfileType["MOL"] = "MOL";
    ProfileType["WOG"] = "WOG";
    ProfileType["GUEST"] = "GUEST";
    ProfileType["GUEST_ENHANCED"] = "GUEST_ENHANCED";
    ProfileType["MOBILE_OTP"] = "MOBILE_OTP";
    ProfileType["SSO"] = "SSO";
    ProfileType["COGNITO"] = "COGNITO";
})(ProfileType || (exports.ProfileType = ProfileType = {}));
class MolUserProfile {
    constructor() {
        this.profileType = ProfileType.MOL;
    }
}
exports.MolUserProfile = MolUserProfile;
class WogUserProfile {
    constructor() {
        this.profileType = ProfileType.WOG;
    }
}
exports.WogUserProfile = WogUserProfile;
class GuestProfile {
    constructor() {
        this.profileType = ProfileType.GUEST;
    }
}
exports.GuestProfile = GuestProfile;
class GuestEnhancedProfile {
    constructor() {
        this.profileType = ProfileType.GUEST_ENHANCED;
    }
}
exports.GuestEnhancedProfile = GuestEnhancedProfile;
class MobileOtpProfile {
    constructor() {
        this.profileType = ProfileType.MOBILE_OTP;
    }
}
exports.MobileOtpProfile = MobileOtpProfile;
class SsoUserProfile {
    constructor() {
        this.profileType = ProfileType.SSO;
    }
}
exports.SsoUserProfile = SsoUserProfile;
class CognitoUserProfile {
    constructor() {
        this.profileType = ProfileType.COGNITO;
    }
}
exports.CognitoUserProfile = CognitoUserProfile;
class GetUnifiedProfileResponseDataApiDomain {
    constructor(props) {
        Object.assign(this, props);
    }
}
exports.GetUnifiedProfileResponseDataApiDomain = GetUnifiedProfileResponseDataApiDomain;
__decorate([
    (0, class_transformer_1.Type)(() => MolUserProfile),
    __metadata("design:type", MolUserProfile)
], GetUnifiedProfileResponseDataApiDomain.prototype, "molUser", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => WogUserProfile),
    __metadata("design:type", WogUserProfile)
], GetUnifiedProfileResponseDataApiDomain.prototype, "wogUser", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => GuestProfile),
    __metadata("design:type", GuestProfile)
], GetUnifiedProfileResponseDataApiDomain.prototype, "guest", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => GuestEnhancedProfile),
    __metadata("design:type", GuestEnhancedProfile)
], GetUnifiedProfileResponseDataApiDomain.prototype, "guestEnhanced", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => MobileOtpProfile),
    __metadata("design:type", MobileOtpProfile)
], GetUnifiedProfileResponseDataApiDomain.prototype, "mobileOtp", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => SsoUserProfile),
    __metadata("design:type", SsoUserProfile)
], GetUnifiedProfileResponseDataApiDomain.prototype, "ssoUser", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => CognitoUserProfile),
    __metadata("design:type", CognitoUserProfile)
], GetUnifiedProfileResponseDataApiDomain.prototype, "cognitoUser", void 0);
class GetUnifiedProfileResponseApiDomain extends service_1.ServiceResponseBodyApiDomain {
    constructor(props) {
        super();
        Object.assign(this, props);
    }
}
exports.GetUnifiedProfileResponseApiDomain = GetUnifiedProfileResponseApiDomain;
//# sourceMappingURL=get-unified-user-api-domain.js.map